import { CircularProgress } from "@material-ui/core"
import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"
import { breakpoints, device } from "../../constants/breakpoints"
import { CardSingle } from "../../containers/home/cards"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import {
  selectFilterLoading,
  selectFilterLoadingMore,
  selectFilterPage,
  selectFilterPagesTotal,
} from "../../redux/filterSlice"
import GlobalIcon from "../Atoms/GlobalIcon"
import {
  CardsSubTitle,
  CardsTitle,
  MobileCardsContainer,
} from "../ChirurghiSearch/styles/ChirurghiSearch.styled"
import ExpandedCard from "../ExpandedCard/ExpandedCard"
import SuggestedCard from "../SuggestedCol/SuggestedCard"
import {
  CardsContainer,
  TabletCardsContainer,
} from "./ExpandedCardsContainer.styled"
import LoadingViewSm from "../LoadingViewSm/LoadingViewSm"
import { Markup } from "interweave"

const NoResultText = styled.p`
  font-size: 22px;
  font-weight: 500;
  margin-top: 20px;
  color: ${props => props.theme.blue};
`

const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;

  @media ${device.tablet} {
    padding-top: 100px;
  }
`

export const SectionTitle = styled.p`
  font-weight: 700;
  font-size: 28px;
  text-align: center;
  color: #082041;
  width: 100%;

  @media ${device.phone} {
    font-size: 22px;
  }
`

export const SectionText = styled.p`
  color: #082041;
  width: 96%;
  padding: 10px;
  margin-right:50px;
`


export const SectionSubTitle = styled.p`
  text-transform: uppercase;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: -2px;
  width: 100%;
  text-align: center;
  color: #337ab7;
  @media ${device.phone} {
    font-size: 16px;
  }
`
export const Title = styled.div`

margin-bottom:20px;
`;

export default function ExpandedCardsContainer({ chirurghi, fetchMore, text }) {
  const loading = useSelector(selectFilterLoading)
  const loadingMore = useSelector(selectFilterLoadingMore)
  const pagesTotal = useSelector(selectFilterPagesTotal)
  const currentPage = useSelector(selectFilterPage)
  const { width } = useWindowDimensions()
  const [endReached, setEndReached] = useState(false)
  const containerRef = useRef()
  const { top, base } = React.useMemo(() => {
    const top = chirurghi.filter(chirurgo => chirurgo.abbonamento.includes("TOP"))
    const base = chirurghi.filter(chirurgo => chirurgo.abbonamento.includes("BASE"))

    return {top, base}
  },[chirurghi])
  const isBottom = el => {
    return el ? el.getBoundingClientRect().bottom <= window.innerHeight : false
  }

  const trackScrolling = () => {
    if (isBottom(containerRef?.current)) {
      setEndReached(true)
    }
  }

  useEffect(() => {
    setEndReached(false)
  }, [currentPage])

  useEffect(() => {
    if (endReached) {
      if (currentPage < pagesTotal) {
        fetchMore && fetchMore(currentPage + 1)
      }
    }
  }, [endReached])

  useEffect(() => {
    document.addEventListener("scroll", trackScrolling)

    return () => document.removeEventListener("scroll", trackScrolling)
  }, [])

  const renderContent = (chirurghi, top) => {
    if (width < breakpoints.tablet ) {
      return (
        <MobileCardsContainer>
          <CardsSubTitle>Contatta il tuo dottore</CardsSubTitle>
          <CardsTitle>Gli specialisti più richiesti</CardsTitle>
          {chirurghi.map((d, i) => (
            <CardSingle key={d.id_sys} doctor={d} />
          ))}
        </MobileCardsContainer>
      )
    }

    if (width < 1100 || !top) {
      return (
        <TabletCardsContainer>
          {chirurghi.map((d, i) => (
            <SuggestedCard
              style={{
                width: width < 1000 ? "35%" : "26%",
                marginTop: 0,
                marginBottom: 30,
                float: "left",
              }}
              key={d.id_sys}
              doctor={d}
            />
          ))}
        </TabletCardsContainer>
      )
    }

    return (
      <CardsContainer>
        {chirurghi.map((d, i) => (
          <ExpandedCard key={d.id_sys} doctor={d} />
        ))}
      </CardsContainer>
    )
  }

  if (loading || !chirurghi) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    )
  }

  if (!chirurghi.length) {
    return (
      <Container>
        { text ? <SectionText><Markup content={text}/><br/></SectionText> :""}
        <GlobalIcon
          style={{ height: 100 }}
          img={require("../../images/not-found.png")}
        />
        <NoResultText>
          Sembra che nessun risultato si adegui ai tuoi filtri...
        </NoResultText>
      </Container>
    )
  }


  return (
    <div ref={containerRef}>
      {top.length > 0 && text ? <SectionText><Markup content={text}/><br/></SectionText> :""}
      {top.length > 0 && <SectionTitle>I nostri miglior chirurghi</SectionTitle>}
      {renderContent(top,true)}
      {base.length > 0 && top.length > 0 && <Title style={{marginTop:20}}> <SectionTitle>Altri chirurghi in zona</SectionTitle></Title>}
      {renderContent(base,false)}
      {loadingMore && <LoadingViewSm />}
    </div>
  )
}
